  <div class="copy-to-clipboard-container">
    <vl-title tag-name="h5">{{title}}</vl-title>
    <vl-input-group>
      <vl-input-addon
        text
        tooltip="Kopieer naar klembord"
        icon="file-copy"
        @click="copyToClipBoard(id)"
      ></vl-input-addon>
      <vl-input-field mod-block
        readonly
        :name="id"
        :id="id"
        v-model="value"
      />
    </vl-input-group>
  </div>
